import { apiFetch } from '../helpers/api-fetch';
import { Mentor } from '../models/mentor';
import { Role } from '../helpers/role';

export class MentorService {

    static readonly APIUrl = process.env.REACT_APP_API_URL as string; // API server domain

    // Get all Users
    public static async getAll() {
        const res = await apiFetch(`${MentorService.APIUrl}/api/mentors`, {
            method: 'GET'
        });
        return Promise.resolve(res);
    }

    // Get User by id
    public static async getById(id: string) {
        const res = await apiFetch(`${MentorService.APIUrl}/api/mentors/${id}`, {
            method: 'GET'
        });
        return Promise.resolve(res);
    }

    // Register a new User or update its data
    public static createOrUpdate(user: Mentor) {
        // set username and role
        user.username = user.email;
        user.role = Role.Mentor;
        
        return apiFetch(`${MentorService.APIUrl}/api/mentors`, {
            method: 'POST',
            body: JSON.stringify(user)
        }).then(res => {
            return Promise.resolve(res);
        });
    }



}